import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { intl } from "LocaleWrapper";
import { useApolloClient } from "@apollo/client";
import { GetFleetsForSelectDocument, GetFleetsForSelectQuery } from "__generated__/view/fleets/graphql/fleet.queries.generated";
import { ChildPropsFromPagination } from "types/commons";

export type FleetSelectOption = ChildPropsFromPagination<GetFleetsForSelectQuery, "fleets">

const FleetSelect = <Multiple extends boolean = false,>({
	...rest
}: Omit<SelectProps<FleetSelectOption, Multiple>, "fetchOptions">) => {
	const client = useApolloClient();

	const onFetchOptions = async() => {
		try {
			const result = await client.query({
				query: GetFleetsForSelectDocument,
			});

			return {
				options: result.data.fleets?.content ?? [],
				totalResults: result.data.fleets?.totalElements ?? 0,
			};
		} catch (response) {
			return {
				options: [],
				totalResults: 0,
			};
		}
	};

	return (
		<Select
			{...rest}
			fetchOptions={onFetchOptions}
			getOptionLabel={option => option.description}
			typeToSearchLabel={intl.formatMessage({ id: "TYPE_TO_SEARCH" })}
			loadingLabel={intl.formatMessage({ id: "LOADING_DATA" })} />
	);
};

export default FleetSelect;
